// extracted by mini-css-extract-plugin
export default {"root":"_3K7oI","large":"_3zggr","medium":"Nc7fK","small":"_1uoZe","daily-deviation":"_2a34o","dailyDeviation":"_2a34o","hype":"_12SgN"};